import React from "react";
import PropTypes from "prop-types";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import NotificationAlert from "react-notification-alert";
import { Link } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { isEmailDomain, isPhoneNumber } from "../../modules/utils";
import TermsAndCondition from "./TermsAndCondition";
//import InputMask from 'react-input-mask';
import MaskedInput from "react-text-mask";
import ReCAPTCHA from "react-google-recaptcha";

function validateInput(data) {
  console.log(!Validator.isEmpty(data.phoneno));
  let errors = {};
  if (Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }
  if (Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }
  if (!Validator.isEmpty(data.phoneno) && !isPhoneNumber(data.phoneno)) {
    errors.phoneno = "Please enter valid phone number";
  }
  if (Validator.isEmpty(data.email)) {
    errors.email = "This field is required";
  }
  if (!isEmailDomain(data.email)) {
    errors.email = "Please enter valid email";
  }
  if (Validator.isEmpty(data.password)) {
    errors.password = "This field is required";
  }
  if (Validator.isEmpty(data.confirm_password)) {
    errors.confirm_password = "This field is required";
  }
  if (!Validator.equals(data.password, data.confirm_password)) {
    errors.confirm_password = "Passwords must match";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class SignUp extends React.Component {
  recaptchaRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      phoneno: "",
      email: "",
      password: "",
      confirm_password: "",
      role: "customer",
      errors: {},
      isLoading: false,
      invalid: false,
      isAgree: false,
      isHuman: false,
      humanKey: null
    };
  }

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  toggleChange = () => {
    this.setState({
      isAgree: !this.state.isAgree
    });
  };

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  _handleSignup = () => {
    if (this.isValid()) {
      if (!this.state.isAgree) {
        this.refs.notify.notificationAlert({
          place: "bl",
          message: (
            <div>
              <div>
                <b>Please Accept Terms And Conditions</b>
              </div>
            </div>
          ),
          type: "danger",
          icon: "now-ui-icons ui-1_bell-53",
          autoDismiss: 7
        });
        return false;
      }

      this.setState({ errors: {}, isLoading: true });
      this.props
        .userSignupRequest(this.state)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.context.router.history.push("/login");
          } else {
            this.refs.notify.notificationAlert({
              place: "bl",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
            this.recaptchaRef.current.reset();
            this.setState({isHuman: false, humanKey: null});
          }
        })
        .catch(error => {
          this.refs.notify.notificationAlert({
            place: "bl",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
          this.setState({ errors: error.response.data, isLoading: false });
          this.recaptchaRef.current.reset();
          this.setState({isHuman: false, humanKey: null});
        });
    }
  };

  isValid = () => {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  };

  // ReCAPTCHA Client Side
  verifyCaptcha = (res) => {
    if(res) {
      this.setState({ isHuman: true, humanKey: res })
    }
  }

  // ReCAPTCHA Expired
  expireCaptcha = () => {
    this.setState({ isHuman: false, humanKey: null })
  }

  render() {
    const { errors } = this.state;
    return (
      <section className="section FullSection">
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-6 no-padding">
            <div className="LoginBanner text-left"></div>
            </div>

            <div className="col-lg-6">
            <div className="text-left SignupFormSet">

            <div className="row justify-content-md-center align-items-center">
              <TermsAndCondition
                show={this.state.show}
                handleClose={this.handleClose}
              />
              <div className="col-md-6">
                <h2 className="font-weight-bold">SIGN UP</h2>

                  <NotificationAlert ref="notify" />
                    <div className="mt-4">
                      <TextFieldGroup
                        error={errors.firstname}
                        placeholder="First Name"
                        type="text"
                        classValue="autocapitalize"
                        onChange={this._onChange}
                        value={this.state.firstname}
                        field="firstname"
                      />
                    </div>

                    <div className="mt-2">
                      <TextFieldGroup
                        error={errors.lastname}
                        placeholder="Last Name"
                        classValue="autocapitalize"
                        type="text"
                        onChange={this._onChange}
                        value={this.state.lastname}
                        field="lastname"
                      />
                    </div>

                    <div style={{ clear: "both", height: "15px" }} />

                    <div className="mt-0">
                      <div style={{ paddingTop: "10px" }}>
                        {/* <lavel calss="control-label"></lavel> */}
                        {/*<InputMask mask="999-999-9999" id="phoneno" name="phoneno" type="text" value={this.state.phoneno} field="phoneno" placeholder="Phone Number" className="form-control autocapitalize" onChange={this._onChange} />*/}
                        <MaskedInput mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]} id="phoneno" name="phoneno" type="text" value={this.state.phoneno} field="phoneno" placeholder="Phone Number" className="form-control autocapitalize" onChange={this._onChange} />
                        <span class="error-color">{errors.phoneno}</span>
                      </div>
                    </div>


                    <div className="mt-2">
                      <TextFieldGroup
                        error={errors.email}
                        placeholder="Email Address"
                        type="text"
                        onChange={this._onChange}
                        value={this.state.email}
                        field="email"
                      />
                    </div>

                    <div style={{ clear: "both", height: "25px" }} />

                    <div className="mt-0">
                      <TextFieldGroup
                        error={errors.password}
                        placeholder="Password"
                        type="password"
                        onChange={this._onChange}
                        value={this.state.password}
                        field="password"
                      />
                    </div>

                    <div className="mt-2">
                      <TextFieldGroup
                        error={errors.confirm_password}
                        placeholder="Confirm Password"
                        type="password"
                        onChange={this._onChange}
                        value={this.state.confirm_password}
                        field="confirm_password"
                      />
                    </div>

                <div style={{ clear: "both", height: "10px" }} />
                  <input
                    id="agreeform"
                    type="checkbox"
                    checked={this.state.isAgree}
                    onChange={this.toggleChange}
                  />{" "}
                   <label for="agreeform" className="signup-notice">I agree to MightyWifi's</label> {" "}
                  <a
                    href="javascript:void(0)"
                    data-toggle="modal"
                    data-target="#myModal"
                  >
                    <span style={{ color: "#000000" }} className="m-break signup-notice">
                      <u>Terms and Conditions</u>
                    </span>
                  </a>

                <div style={{ clear: "both", height: "20px" }} />
                <ReCAPTCHA
                    ref={this.recaptchaRef}
                    sitekey={'6LdUIyweAAAAAOs44Nk0ouoOHyz1YlbNMCJuBHfo'}
                    // render="explicit"
                    onChange={this.verifyCaptcha}
                    onExpired={this.expireCaptcha}
                />

                <div style={{ clear: "both", height: "15px" }} />

                <a
                  href="javascript:void(0)"
                  onClick={this._handleSignup}
                  className="btn btn-orange"
                >
                  SIGN UP
                </a>

                <div style={{ clear: "both", height: "100px" }} />
              </div>
            </div>
            </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

SignUp.propTypes = {
  userSignupRequest: PropTypes.func.isRequired,
  addFlashMessage: PropTypes.func.isRequired
};

SignUp.contextTypes = {
  router: PropTypes.object.isRequired
};

export default SignUp;



// WEBPACK FOOTER //
// ./src/pages/signup/SignUpForm.js